import { Component, OnInit, Inject } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog,
} from "@angular/material/dialog";
import { ProyectosService } from "src/app/proyectos/proyectos.service";
import { ConsultaList } from "src/app/shared/model/core/ConsultaList.model";
import { Cliente } from "src/app/shared/model/ajustesUsuario/cliente.model";
import { Proyecto } from "src/app/shared/model/gestion-proyectos/proyecto";
import { GestionclientesService } from "src/app/clientes/gestionclientes.service";
import { OperativoService } from "../../../opeartivo.service";
import { GrupoYears } from "../../../modelos/modelo-grupo-years.model";
import { ModalAgregarNombreGruposComponent } from "../../../grupos/agregar-grupos/modal-agregar-nombre-grupos.component";
import { Base } from "src/app/shared/model/core/base.model";
import { AddclientemodalComponent } from "src/app/clientes/addclientemodal/addclientemodal.component";
import swal from "sweetalert2";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { ProductoCliente } from "src/app/shared/model/gestion-proyectos/productoCliente";
import { Servicio } from "src/app/shared/model/gestion-proyectos/servicio";
import { TipoOportunidad } from "src/app/shared/model/gestion-proyectos/tipoOportunidad.model";
import { Router } from "@angular/router";
import { Msg } from "src/app/utilerias/mensajes/Msg";

// Angular core y formularios
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";

// Angular Material
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatNativeDateModule } from "@angular/material/core"; // ⬅ Necesario para que funcione el datepicker con fechas nativas
import { MatCheckboxModule } from "@angular/material/checkbox"; // FIX: para <mat-checkbox>
import { MatListModule } from "@angular/material/list"; // FIX: para mat-selection-list / mat-list-option

// Módulo de búsqueda dentro de mat-select
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";

// DataTables para Angular
import { MatRadioButton } from "@angular/material/radio";

@Component({
  selector: "app-modal-agregar-oportunidad",
  standalone: true,
  templateUrl: "./modal-agregar-oportunidad.component.html",
  styleUrls: ["./modal-agregar-oportunidad.component.css"],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxMatSelectSearchModule,
    MatCheckboxModule, // FIX
    MatListModule, // FIX
  ],
})
export class ModalAddOportComponent implements OnInit {
  formStageEmployee: FormGroup;
  step: number;
  objectEtapa: Proyecto;
  modeEditable: boolean = false;
  titleModal: string;
  clientes: Cliente[];
  listaGrupos: GrupoYears[];
  proyecto: Proyecto = new Proyecto();
  idGenerado: any;
  // Variables para el filtro del cliente
  formCliente = new FormControl();
  requestCliente = new ConsultaList<Cliente>();
  regPagCliente = 1000;
  // variables para el filtro del grupo
  formGrupo = new FormControl();
  grupofl: number = null;
  requestGrupo = new ConsultaList<GrupoYears>();
  regPagGrupo = 1000;
  // Variables para la carga de documentos
  evidencia = [];
  selectedOptions = [];
  index: number;
  btnElimina: boolean = true;
  btnAgrega: boolean = false;
  totalsize = 0;
  // Variables para las fechas
  today: Date = new Date();
  minDate = new Date();
  minDateVigencia: Date;
  maxDate = new Date();
  maxDateVigencia: Date;
  //
  clientefl: number = null;
  idMostrar: boolean = false;
  tiposOportunidad = null;
  listaGruposXTipo: any[] = [];
  mostrarGrupos: boolean = false;
  idPadre: number;
  esNuevoProducto: boolean = false;
  listProducto: ProductoCliente[] = [];
  producto: ProductoCliente = new ProductoCliente();
  idProductoSelect: number;
  listServicios: Servicio[] = [];
  idClienteRelacionado: number;
  idServicioSeleccionado: number;
  idGeneradoExito: boolean = false;
  idSeleccionado: number;

  constructor(
    public dialogRef: MatDialogRef<ModalAddOportComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private proyectosService: ProyectosService,
    private clientService: GestionclientesService,
    private servicioOperativo: OperativoService,
    public modalDialog: MatDialog,
    private router: Router,
    public msg: Msg
  ) {}

  ngOnInit() {
    this.minDate.setDate(this.minDate.getDate());
    this.maxDate.setMonth(this.maxDate.getMonth() + 11);

    this.formStageEmployee = this.formBuilder.group({
      tipoOportunidadCtrl: ["", Validators.required],
      nameProjectCtrl: ["", Validators.required],
      customerCtrl: ["", Validators.required],
      groupCtrl: ["", Validators.required],
      descriptionProjectCtrl: [""],
      commentProjectCtrl: ["", Validators.required],
      dateEstimateProjectCtrl: [""],
      idProyecto: [""],
      productoCtrl: [""],
      nombreProducto: [""],
      servicioCtrl: [""],
    });

    if (this.data.id !== null && this.data.id !== undefined) {
      this.step = 0;
      this.objectEtapa = this.data as Proyecto;
      this.modeEditable = true;
      this.titleModal = "Editar Oportunidad";
      this.evidencia = this.data.archivos;
    } else {
      this.objectEtapa = new Proyecto();
      this.step = 0;
      this.modeEditable = false;
      this.titleModal = "Alta Oportunidad";
    }
    this.consultaClientes();
    this.consultaGrupos();
    this.consultaServicios();
    this.consultaTipoOportunidades();
    this.requestCliente.regInicial = 0;
    this.requestCliente.regXPagina = this.regPagCliente;
    this.formCliente.valueChanges.subscribe(() => {
      this.filtraCliente();
    });

    this.requestGrupo.regInicial = 0;
    this.requestGrupo.pagina = 0;
    this.requestGrupo.regXPagina = this.regPagGrupo;
    this.formGrupo.valueChanges.subscribe(() => {
      this.filtrarGrupo();
    });
  }

  consultaTipoOportunidades() {
    this.servicioOperativo.consultaTipoOportunidades().subscribe((resp) => {
      this.tiposOportunidad = resp.list;
    });
  }

  seleccionaTipoOp(): void {
    const tipo = this.formStageEmployee.get("tipoOportunidadCtrl").value;
    if (!tipo) return;

    this.idSeleccionado = tipo.id_grupo_git;
    this.consultaGruposXTipo(this.idSeleccionado);

    console.log("Tipo seleccionado:", tipo);
    console.log("id_grupo_git:", this.idSeleccionado);
  }

  onNoClick() {
    this.dialogRef.close("00000");
  }

  clear(): void {
    this.formStageEmployee.reset();
  }

  consultaClientes(): void {
    this.proyectosService
      .findAllCustomers(new Cliente())
      .subscribe((response) => {
        if (response !== null && response !== undefined) {
          this.clientes = response;
        }
      });
  }

  clearNombreCli() {
    this.clientefl = null;
    this.formCliente.setValue("");
    this.consultaClientes();
  }

  consultaGrupos() {
    this.servicioOperativo
      .consultarGrupos(new GrupoYears())
      .subscribe((response) => {
        if (response !== null && response !== undefined) {
          this.listaGrupos = response;
        }
      });
  }

  clearNombreGrup() {
    this.grupofl = null;
    this.formGrupo.setValue("");
    this.consultaGrupos();
  }

  subirEv() {
    const input = <HTMLInputElement>document.getElementById("nameFile");
    if (input.files.length > 0) {
      for (let i = 0; i <= input.files.length - 1; i++) {
        this.totalsize = this.totalsize + input.files.item(i).size;
        const exists = this.evidencia.some(
          (existingFile) =>
            existingFile.name === input.files[i].name &&
            existingFile.size === input.files[i].size
        );

        if (!exists) {
          this.evidencia.push(input.files[i]);
        }
      }
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  elimina() {
    for (let i = 0; i < this.selectedOptions.length; ++i) {
      this.index = this.evidencia.findIndex(
        (item) => item.name == this.selectedOptions[i].name
      );
      this.evidencia.splice(this.index, 1);
    }
    (<HTMLInputElement>document.getElementById("nameFile")).value = "";
  }

  onNgModelChange($event) {
    this.selectedOptions = $event;
    if (this.selectedOptions.length != 0) {
      this.btnElimina = false;
      this.btnAgrega = true;
    } else {
      this.btnElimina = true;
      this.btnAgrega = false;
    }
  }

  filtraCliente() {
    if (!this.clientes) {
      this.clientService
        .filtroBusquedaCliente(this.requestCliente)
        .subscribe((res) => {
          this.clientes = res.list;
        });
    }
    let search = this.formCliente.value;
    if (!search && this.clientes) {
      return;
    } else {
      search = search.toLowerCase();
    }
    this.requestCliente.param1 = search;
    this.clientService
      .filtroBusquedaCliente(this.requestCliente)
      .subscribe((res) => {
        this.clientes = res.list;
      });
  }

  agregarCliente() {
    const dialogRef = this.modalDialog.open(AddclientemodalComponent, {
      height: "720px",
      width: "1200px",
      panelClass: "custom-modalbox",
    });
    dialogRef.afterClosed().subscribe((res: Base) => {
      if (res.pCodRetorno === "00000") {
        this.consultaClientes();
      }
    });
  }

  filtrarGrupo() {
    if (!this.listaGrupos) {
      this.servicioOperativo
        .getGroupsWithPagination(this.requestGrupo)
        .subscribe((res) => {
          this.listaGrupos = res.content;
        });
    }
    let search = this.formGrupo.value;
    if (!search && this.listaGrupos) {
      return;
    } else {
      search = search.toLowerCase();
    }
    this.requestGrupo.param1 = search;
    this.requestGrupo.param4 = null;
    this.servicioOperativo
      .getGroupsWithPagination(this.requestGrupo)
      .subscribe((res) => {
        this.listaGrupos = res.content;
      });
  }

  agregarGrupo() {
    const dialogRef = this.modalDialog.open(ModalAgregarNombreGruposComponent, {
      disableClose: true,
      autoFocus: true,
      width: "60%",
      panelClass: "custom-modalbox",
      data: this.idSeleccionado,
    });

    dialogRef.afterClosed().subscribe((res: Base | null) => {
      if (res && res.pCodRetorno === "00000") {
        // ← validar res
        this.consultaGrupos();
        this.consultaGruposXTipo(this.idPadre);
      }
    });
  }

  agregarEstimacion(evento) {
    this.proyecto.checkvalidacion = evento.target.checked;
  }

  consultaGruposXTipo(idPadre: number): void {
    this.servicioOperativo.consultaGruposIdPadre(idPadre).subscribe((res) => {
      if (Array.isArray(res) && res.length > 0) {
        this.listaGruposXTipo = res;
      }

      this.mostrarGrupos = true;
      console.log("Grupos por tipo:", this.mostrarGrupos);
      this.idPadre = idPadre;
    });
  }

  seleccionCliente(event: any) {
    if (event.value) {
      const clienteSeleccionado = this.clientes.find(
        (cliente) => cliente.id === event.value
      );
      if (clienteSeleccionado) {
        this.proyecto.nombre_corto = clienteSeleccionado.nombre_corto;
        this.idClienteRelacionado = clienteSeleccionado.id;
        this.consultaProductosCliente(clienteSeleccionado.id);
      } else {
        console.log("Cliente no encontrado para el ID:", event.value);
      }
    }
  }

  save(): void {
    // Build evidencia array para enviar
    var listaevidencia = [];
    if (this.evidencia.length > 0) {
      this.evidencia.forEach((element) => {
        var evidenciasoportunidad = {
          name: element.name,
          type: element.type,
        };
        listaevidencia.push(evidenciasoportunidad);
      });

      this.proyecto.archivos = listaevidencia;
      const formData = new FormData();
      for (let i = 0; i < this.evidencia.length; i++) {
        formData.append(
          "file",
          this.evidencia[i],
          "Solser Desarrollo" +
            "$" +
            this.proyecto.grupo +
            "$" +
            this.proyecto.nombreCliente +
            "$" +
            "Documentos" +
            "$" +
            this.evidencia[i].name
        );
      }
      // Subida asíncrona; no bloqueamos el flujo aquí (igual que en tu versión original)
      this.servicioOperativo.uploadFiles(formData).subscribe();
    }

    // Mapeo de campos del formulario a proyecto
    this.proyecto.nombre =
      this.formStageEmployee.controls.nameProjectCtrl.value;
    this.proyecto.idCliente =
      this.formStageEmployee.controls.customerCtrl.value;
    this.proyecto.descripcion =
      this.formStageEmployee.controls.descriptionProjectCtrl.value;
    this.proyecto.fechaEstimacion =
      this.formStageEmployee.controls.dateEstimateProjectCtrl.value;
    this.proyecto.grupo = this.formStageEmployee.controls.groupCtrl.value;
    if (this.idGenerado != null && this.idGenerado != undefined) {
      this.proyecto.idProyecto = this.idGenerado.idProyecto;
    }

    this.proyecto.tipo = "OPORTUNIDAD";
    this.proyecto.idPadre = this.idPadre;

    // FIX: Si idClienteRelacionado está presente, usarlo para setear nombreCliente (evita confusión con clientefl)
    if (this.idClienteRelacionado) {
      const cliente = this.clientes?.find(
        (c) => c.id === this.idClienteRelacionado
      );
      if (cliente) {
        this.proyecto.nombreCliente = cliente.razonsocial;
      }
    } else {
      // Mantener tu lógica original por si usas clientefl en otros flujos
      this.clientes.forEach((element) => {
        if (this.clientefl)
          if (element.id === this.clientefl) {
            this.proyecto.nombreCliente = element.razonsocial;
          }
      });
    }

    // Comentarios y producto (se movió aquí para que estén antes de la validación)
    var listaComentarios = [];
    var arregloComentarios = {
      idGit: 0,
      idComentario: 0,
      contenido: this.formStageEmployee.controls.commentProjectCtrl.value,
      estado: null,
      fecha: null,
      idUser: 0,
      username: null,
      nombreUsuario: null,
      archivosComentarios: [],
    };
    listaComentarios.push(arregloComentarios);
    this.proyecto.comentarios = listaComentarios;
    this.proyecto.producto = this.idProductoSelect;

    // DEBUG logs
    console.log(this.proyecto);
    console.log("=== DEBUG OPORTUNIDAD ===");
    console.log("Proyecto a guardar:", JSON.stringify(this.proyecto, null, 2));
    console.log("Grupo seleccionado:", this.proyecto.grupo);
    console.log("IdPadre:", this.proyecto.idPadre);
    console.log("Archivos:", this.proyecto.archivos);
    console.log("Comentarios:", this.proyecto.comentarios);
    console.log("Producto:", this.proyecto.producto);
    console.log("=========================");

    // Validación y guardado
    this.servicioOperativo
      .validarOportunidad(this.proyecto)
      .subscribe((res) => {
        if (res.pCodRetorno !== "00000") {
          const swalWithBootstrapButtons = swal.mixin({
            customClass: {
              confirmButton: "btn btn-success",
            },
            buttonsStyling: false,
          });
          swalWithBootstrapButtons.fire({
            title: "Alerta",
            html:
              "<p>No es posible realizar la accion. </p> " +
              "<p> Ya se encuentra registrado un proyecto con ese nombre.</p>",
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "Continuar",
            reverseButtons: true,
          });
        } else {
          this.servicioOperativo.saveProyect(this.proyecto).subscribe((res) => {
            if (res.pCodRetorno === "00000" || res.pCodRetorno === "24406") {
              var mensaje =
                "<p>La oportunidad se ha guardado " +
                (res.pCodRetorno === "24406"
                  ? "pero uno o mas archivos no se pudieron subir, válide e intente subirlos nuevamente."
                  : " correctamente.") +
                "</p>";

              const swalWithBootstrapButtons = swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success",
                },
                buttonsStyling: false,
              });
              swalWithBootstrapButtons
                .fire({
                  title: "Alerta",
                  html: mensaje,
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                  reverseButtons: true,
                })
                .then((result) => {
                  if (result.isConfirmed) {
                    this.dialogRef.close(res);
                    this.formStageEmployee.reset();
                  }
                });
            } else {
              var errorGit = res.pCodRetorno.startsWith("244");
              var mensaje = "<p> No se pudo crear la oportunidad. ";
              if (errorGit) {
                mensaje +=
                  res.pMensaje +
                  " ¿Desea generar un ticket para solicitar ayuda? </p>";
              } else if (res.pCodRetorno === "00002") {
                mensaje +=
                  "Verifique que el cliente tenga un nombre corto válido.</p>";
              }

              const swalWithBootstrapButtons = swal.mixin({
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-danger",
                },
                buttonsStyling: false,
              });
              swalWithBootstrapButtons
                .fire({
                  title: "Alerta",
                  html: mensaje,
                  icon: "error",
                  showCancelButton: errorGit,
                  cancelButtonText: "Cerrar",
                  confirmButtonText: "Continuar",
                  reverseButtons: true,
                })
                .then((callback) => {
                  if (errorGit && callback.isConfirmed) {
                    this.router.navigate(["/TICKETS/Cte"]);
                    this.dialogRef.close();
                  }
                });
            }
          });
        }
      });
  }

  guardaProducto() {
    // FIX: preferir idClienteRelacionado (se setea en seleccionCliente); si no está, usar el control del form como fallback
    this.producto.id_cliente =
      this.idClienteRelacionado ||
      this.formStageEmployee.get("customerCtrl").value;
    this.producto.estatus = "ACTIVO";
    this.producto.producto = this.formStageEmployee.get("nombreProducto").value;
    this.proyectosService
      .guardaProductoCliente(this.producto)
      .subscribe((response) => {
        if (response) {
          swal.fire({
            title: "El producto se registró exitosamente",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
            confirmButtonText: "Aceptar",
            icon: "success",
          });
          this.idMostrar = true;
        }

        // FIX: comprobar response antes de leer id_producto
        if (response && response.id_producto) {
          this.idProductoSelect = response.id_producto;
          // refrescar la lista con el id cliente real (idClienteRelacionado o el control)
          const clienteIdForRefresh =
            this.idClienteRelacionado ||
            this.formStageEmployee.get("customerCtrl").value;
          if (clienteIdForRefresh) {
            this.consultaProductosCliente(clienteIdForRefresh);
          }
          this.esNuevoProducto = false;
          // limpiar campo nombreProducto para que el *ngIf del botón responda
          if (this.formStageEmployee.get("nombreProducto")) {
            this.formStageEmployee.get("nombreProducto").reset();
          }
        } else {
          // Si no vino id_producto, mostrar aviso (opcional)
          console.warn("Respuesta guardaProducto sin id_producto:", response);
        }
      });
  }

  nuevoProducto(valor: MatCheckboxChange) {
    if (valor.checked == true) {
      this.esNuevoProducto = true;
      this.idProductoSelect = null;
    } else {
      this.esNuevoProducto = false;
      this.idProductoSelect = null;
    }
  }

  consultaProductosCliente(clienteSeleccionado: number) {
    this.proyectosService
      .obtenerProductosCliente(clienteSeleccionado)
      .subscribe((response) => {
        if (response !== null && response !== undefined) {
          // tu API devuelve response.list según tu código original
          this.listProducto = response.list;
        }
      });
  }

  seleccionarProducto(event: any) {
    this.idProductoSelect = event.value;
  }

  seleccionarServicio(event: any) {
    this.proyecto.servicio = event.value;
    if (this.proyecto.servicio != null && this.proyecto.servicio != undefined) {
      this.idServicioSeleccionado = this.proyecto.servicio;
      if (
        this.idClienteRelacionado &&
        this.idProductoSelect &&
        this.idServicioSeleccionado
      ) {
        this.generarBtn();
      } else {
        this.formStageEmployee.get("servicioCtrl").setValue("");
        swal.fire({
          title:
            "Algún dato no ha sido seleccionado; verificar el cliente, producto o servicio.",
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-success",
            cancelButton: "btn btn-danger",
          },
          confirmButtonText: "Aceptar",
          icon: "error",
        });
      }
    }
  }

  consultaServicios() {
    this.proyectosService.obtenerServicios().subscribe((response) => {
      if (response !== null && response !== undefined) {
        this.listServicios = response.list;
      }
    });
  }

  generarBtn() {
    if (this.proyecto.nombre_corto)
      this.proyectosService
        .generarIdProyecto(
          this.idClienteRelacionado,
          this.idProductoSelect,
          this.idServicioSeleccionado
        )
        .subscribe(
          (response: any) => {
            this.idGenerado = response;
            if (this.idGenerado.codRet === "00000") {
              this.idGeneradoExito = true;
              swal.fire({
                title: "Se registró el Id: " + this.idGenerado.idProyecto,
                buttonsStyling: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-danger",
                },
                confirmButtonText: "Aceptar",
                icon: "success",
              });
            } else this.msg.errorCall(this.idGenerado.mensaje, "Error", null);
          },
          (error) => {
            console.error("Error al generar el ID del proyecto:", error);
          }
        );
    else
      this.msg.errorCall(
        "El cliente seleccionado no tiene un nombre corto válido.",
        "Error",
        null
      );
  }
}
